import "./VideoWithPoster.scss";
import { VideoProps } from "/Models/Generated/VideoProps";
import { Picture, Video, YouTubeEmbed, VideoPlayButton } from "/App.Components";
import { PictureAspectRatio, PictureBehaviour } from "../Picture/Picture";
import { createSpreadableBem } from "/Helpers/createBem";

interface Props extends VideoProps {
  posterBehaviour?: PictureBehaviour;
  posterAspectRatio?: PictureAspectRatio;
  posterClicked: boolean;
  setPosterClicked: () => void;
  eagerLoading?: boolean;
}

const VideoWithPoster = (props: Props) => {
  const {
    youTubeEmbedCode,
    videoUrl,
    posterImage,
    ariaLabel,
    duration,
    durationAriaLabel,
    youTubeTitle,
    description,
    posterClicked,
    setPosterClicked,
    posterBehaviour,
    posterAspectRatio,
    eagerLoading = true,
  } = props;
  const ua =
    typeof window !== "undefined" ? window.navigator.userAgent : undefined;
  const iOS = !!ua?.match(/iPad/i) || !!ua?.match(/iPhone/i);
  const webkit = !!ua?.match(/WebKit/i);
  const iOSSafari = iOS && webkit && !ua?.match(/CriOS/i);
  const playLabel = (ariaLabel ?? "Spill av video").trim();
  const videoDescription = description?.trim();
  const buttonAriaLabel = [
    playLabel,
    videoDescription,
    (durationAriaLabel ?? duration)?.trim(),
  ]
    .filter(Boolean)
    .join(", ");

  // eslint-disable-next-line eqeqeq
  const autoPlay = posterImage != null;

  const inner = youTubeEmbedCode ? (
    <YouTubeEmbed
      embedCode={youTubeEmbedCode}
      autoPlay={autoPlay}
      title={youTubeTitle}
    />
  ) : (
    videoUrl && <Video {...{ videoUrl }} autoPlay={autoPlay} />
  );
  const bem = createSpreadableBem("video-with-poster");
  return (
    <div {...bem("")}>
      {!posterClicked && posterImage && !iOSSafari && (
        <button
          {...bem("__poster", {
            "--full-width": posterBehaviour === "FullWidth",
            "--ratio-16-9": posterAspectRatio === "16/9",
          })}
          onClick={() => setPosterClicked()}
          aria-label={buttonAriaLabel}
        >
          <Picture
            {...posterImage}
            noAlt
            pictureBehaviour={posterBehaviour}
            pictureAspectRatio={posterAspectRatio}
            eagerLoading={eagerLoading}
          />
          <span {...bem("__play-button")}>
            <VideoPlayButton />
          </span>
        </button>
      )}

      {posterClicked || !posterImage || iOSSafari ? inner : null}
    </div>
  );
};
export default VideoWithPoster;
